import { Button } from '@repo/atomic-components';

interface ErrorFallbackAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
}

interface ErrorFallbackProps {
  title: string;
  description: string;
  primaryAction?: ErrorFallbackAction;
  /** Optional secondary escape hatch, e.g. "Back to chat". */
  secondaryAction?: ErrorFallbackAction;
}

/** Fallback UI for a caught render error or a failed load. Doesn't show error details — those are in the console. */
export const ErrorFallback = ({ title, description, primaryAction, secondaryAction }: ErrorFallbackProps) => (
  <div role="alert" className="flex h-full w-full items-center justify-center p-6">
    <div className="flex max-w-md flex-col items-center gap-3 text-center">
      <h1 className="text-theme-black text-lg font-semibold">{title}</h1>
      <p className="text-theme-text-grey text-sm leading-5">{description}</p>
      <div className="mt-3 flex items-center gap-3">
        {secondaryAction && (
          <Button
            outlined
            onClick={secondaryAction.onClick}
            disabled={secondaryAction.disabled}
            className="!text-theme-black !border-theme-border-grey hover:bg-theme-background-grey! !bg-theme-white flex h-8 items-center justify-center px-3 text-sm"
          >
            {secondaryAction.label}
          </Button>
        )}
        {primaryAction && (
          <Button
            onClick={primaryAction.onClick}
            disabled={primaryAction.disabled}
            className="bg-theme-dark-green hover:bg-theme-dark-green text-theme-white flex h-8 items-center justify-center px-3 text-sm"
          >
            {primaryAction.label}
          </Button>
        )}
      </div>
    </div>
  </div>
);
